"use strict";
var Observable_1 = require('../../Observable');
var bufferWhen_1 = require('../../operator/bufferWhen');
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1143190010/src/~/rxjs/add/operator/bufferWhen.js
// module id = UVHa
// module chunks = 6